import clsx from 'clsx'
import { useContext } from 'react'

import { TableContext } from './context'

export function StickyCellBorder ({ sticky }: { sticky?: boolean }) {
  const { isScrolled } = useContext(TableContext)

  return (
    <div
      className={clsx({
        'bg-gray-200 absolute -right-px w-px top-0 bottom-0':
          isScrolled && sticky,
        'bg-transparent': !isScrolled || !sticky,
      })}
    />
  )
}
